<div>

  <div fxLayout="row" fxLayoutAlign="start center" style="margin-top:30px">

    <div fxFlex="2">
    </div>


    <div id="radiobuttons-div" fxFlex="47">
      <mat-radio-group id="radiobuttons">
        <mat-radio-button class="mat-radio-button" value="1" i18n="@@devicelog_today" (change)="setLogTimeRange($event)"
          [checked]="true">Oggi
        </mat-radio-button>
        <mat-radio-button class="mat-radio-button" value="2" (change)="setLogTimeRange($event)"
          i18n="@@devicelog_yesterday">Ieri
        </mat-radio-button>
        <mat-radio-button class="mat-radio-button-custom" value="3" (change)="setLogTimeRange($event)"
          i18n="@@devicelog_custom">
          Personalizzato</mat-radio-button>
      </mat-radio-group>
    </div>

    <div fxFlex="6">
      <button (click)="refreshData()" mat-mini-fab>
        <fa-icon id="refesh-data-icon" icon="redo"></fa-icon>
      </button>
    </div>

    <div fxFlex="14">
      <a (click)="downloadCsv()" class="button" id="downloadCsvButton">
        <ng-container i18n="@@accesslog_download_csv">Download CSV</ng-container> <span>
          <fa-icon icon="file-export"></fa-icon>
        </span>
      </a>
    </div>
<!-- Conferma download log -->
    <div fxFlex="2">
      <p style="margin-top:8px" i18n="@@accesslog_filter">Filtra:</p>
    </div>

    <div fxFlex="25" class="table-filter">
      <input id="filter-input" (keyup)="onKey($event)" />
    </div>

    <div fxFlex>
    </div>
  </div>

  <!-- <div id="radiobuttons-div">

    <mat-radio-group id="radiobuttons">
      <mat-radio-button class="mat-radio-button" value="1" i18n="@@accesslog_today" (change)="setLogTimeRange($event)"
        [checked]="true">Oggi
      </mat-radio-button>
      <mat-radio-button class="mat-radio-button" value="2" (change)="setLogTimeRange($event)"
        i18n="@@accesslog_yesterday">Ieri
      </mat-radio-button>
      <mat-radio-button class="mat-radio-button" value="3" (change)="setLogTimeRange($event)" i18n="@@accesslog_custom">
        Personalizzato</mat-radio-button>
    </mat-radio-group>
  </div>

  <div id="table-filter-container">
    <div class="table-filter">
      <input id="filter-input" (keyup)="onKey($event)" />
      <p i18n="@@accesslog_filter">Filtra: </p>

    </div>
  </div> -->

  <br clear="all">
  <br>
  <div id="datepickers-div" *ngIf="showDatePickers">

    <div id="from-datepicker-div">
      <p class="text-small text-dark" i18n="@@accesslog_start_date">
        Data di inizio:
      </p>
      <input id="from-datepicker-input" [matDatepicker]="fromDatepicker" [formControl]="fromFormControl">
      <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
      <mat-datepicker #fromDatepicker></mat-datepicker>
    </div>
    <div id="to-datepicker-div">
      <p class="text-small text-dark" i18n="@@accesslog_end_date">
        Data di fine:
      </p>
      <input id="to-datepicker-input" [matDatepicker]="toDatepicker" [formControl]="toFormControl">
      <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
      <mat-datepicker #toDatepicker></mat-datepicker>
    </div>
    <div id="confirm-button-div">
      <a id="confirmButton" class="button" (click)="confirmDateSelection()">
        <ng-container i18n="@@accesslog_confirm">Conferma</ng-container> <span>
          <fa-icon icon="check"></fa-icon>
        </span>
      </a>
    </div>
  </div>

  <br clear="all" />
  <br clear="all" />


  <div class="control-card-content">

    <mat-paginator (page)="changePage($event)" [pageIndex]="currentPage" [length]="tableItemsTotalCounter"
      [pageSizeOptions]="pageSizeOptions">
    </mat-paginator>

    <div class="table-container" id="device-log-wrapper">

      <table mat-table matSort #accesslogtable class="simple-table">

        <ng-container matColumnDef="date">
          <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@accesslog_date" style="width: 25%; ">Data</th>
          <td mat-cell *matCellDef="let element"> {{ element.dateFriendly }} </td>
        </ng-container>

        <ng-container matColumnDef="subscription">
          <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@accesslog_subscription" style="width: 17%; ">
            Abbonamento</th>
          <td mat-cell *matCellDef="let element"> {{ element.userOwnerName }} </td>
        </ng-container>

        <!-- <ng-container matColumnDef="activationCode">
          <th mat-header-cell *matHeaderCellDef i18n="@@activationCode" style="width: 13%; ">Descrizione</th>
          <td mat-cell *matCellDef="let element">
            <div>{{element.activationCode}}</div>
          </td>
        </ng-container> -->

        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef i18n="@@accesslog_user" style="width: 17%; ">Identificativo</th>
          <td mat-cell *matCellDef="let element">
            <div> {{element.code}} </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef i18n="@@accesslog_state" style="width: 16%; ">Stato</th>
          <td mat-cell *matCellDef="let element">
            <div>{{element.tableState}}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="method">
          <th mat-header-cell *matHeaderCellDef i18n="@@accesslog_method" style="width: 25%;">Metodo</th>
          <td mat-cell *matCellDef="let element">
            <div style=" display: inline-block ; width: 35% ; vertical-align: middle; text-align:center;">
              <fa-icon
                *ngIf="isSelectIconType(element)"
                icon={{selectIcon(element.way)}} class="fa-lg">
              </fa-icon>
              <img *ngIf="element.way == remote1cType" class="customIcon" src="/assets/icons/why.svg" />
              <img *ngIf="element.way == remoteType" class="customIcon" src="/assets/icons/jcm.svg" />
            </div>
            <div style=" display: inline-block ; width: 65% ;">
              {{ element.tableWay }}
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"
          [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
        </tr>
      </table>
    </div>
  </div>
  <app-loading-screen #logloader></app-loading-screen>
  
</div>